<template>
  <!-- ユーザ検索 -->
  <div id="AppUserManagementSearchUser">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box">
      <template :searchConditions="searchConditions">
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所" labelPosition="on-border">
              <b-select expanded v-model="searchConditions.officeCode">
                <option />
                <option
                  v-for="office in officeMaster"
                  :value="office.officeCode"
                  :key="office.officeCode"
                >{{ office.officeName }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="姓" labelPosition="on-border">
              <b-input
                v-model="searchConditions.lastName"
                name="lastName"
                data-vv-as="姓"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.firstName"
                name="firstName"
                data-vv-as="名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column">
            <b-field label="権限" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button v-model="searchConditions.roleGroup" native-value="4">点検者</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.roleGroup" native-value="3">点検管理者</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.roleGroup" native-value="5">GSS管理者</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.roleGroup" native-value="6">営業管理者</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.roleGroup" native-value="2">コールセンター</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.roleGroup" native-value="7">待機当番のみ</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.roleGroup" native-value="1">システム管理者</b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search()"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <section>
      <div class="box" style="resultArea;" v-show="hasResult">
        <div class="columns">
          <div class="column is-one-third" style="text-align:left;">
            <b-button
              v-if="roleId===1"
              class="button is-primary has-text-centered"
              icon-left="download"
              native-type="button"
              v-on:click="downloadPlan"
            >ダウンロード</b-button>
          </div>
          <div class="column">
            <b-field horizontal label="患者検索結果" style="float:right; white-space:nowrap;">
              <b-select position="is-right" v-model="perPage">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div>
          <b-table
            :data="searchResult"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="staffCode"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column
                field="officeCode"
                label="営業所"
                sortable
                centered
                style="width:90px;"
              ><div style="text-align: left;">{{ props.row.officeCode | officeFilter }}</div></b-table-column>
              <b-table-column
                field="staffCode"
                label="点検担当者コード"
                sortable
                centered
                style="width:100px;"
              >{{ props.row.staffCode }}</b-table-column>
              <b-table-column
                field="lastName"
                label="名前"
                sortable
                centered
              >
                {{ getRowItem(props.row.lastName + props.row.firstName,16) }}
              </b-table-column>
              <b-table-column
                field="lastNameKana"
                label="名前（カナ）"
                sortable
                centered
              >
                {{ getRowItem(props.row.lastNameKana + props.row.firstNameKana,16) }}
              </b-table-column>
              <b-table-column
                field="role"
                label="権限"
                sortable
                centered
              >{{ props.row.role | roleFilter}}</b-table-column>
              <b-table-column
                field="officePhoneNumber"
                label="電話番号(直通)"
                sortable
                centered
              >{{ props.row.officePhoneNumber }}</b-table-column>
              <b-table-column
                field="mobilePhoneNumber"
                label="電話番号(携帯)"
                sortable
                centered
              >{{ props.row.mobilePhoneNumber }}</b-table-column>
              <b-table-column
                field="email"
                label="メールアドレス"
                sortable
                centered
              >{{ getRowItem(props.row.email,40) }}</b-table-column>
              <b-table-column
                field="positionName"
                label="役職"
                sortable
                centered
              >{{ props.row.positionName}}</b-table-column>
              <b-table-column v-if="roleId===1" label=" 編集/削除" centered style="width:70px;">
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="pencil"
                  native-type="button"
                  size="is-small"
                  v-on:click="refDetail(props.row.id)"
                ></b-button>
                <b-modal :active.sync="isUserEditActive" has-modal-card>
                  <userEdit-modal v-bind:selectedid="selectedid"></userEdit-modal>
                </b-modal>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="account-remove"
                  native-type="button"
                  size="is-small"
                  @click="confirmCustomDelete(props.row.id, props.row.email)"
                ></b-button>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </section>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import userEditTemplate from "./AppUserManagementEditUserContents";
var searchResult = [];
var officeMaster = [];
const userEditForm = {
  components: {
    userEdit: userEditTemplate
  },
  props: ["selectedid"],
  methods: {
    doSave: function(event) {
      this.$refs.editContents.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.editContents.update().then(result => {
            if (this.$refs.editContents.isSuccessEnd()) {
              this.$parent.close();
            }
          });
        } else {
          scrollTo(0, 0);
        }
      });
    }
  },
  template: `
        <form action="">
          <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">ユーザ情報変更</p>
          </header>
          <div class="modal-card">
            <section class="modal-card-body">
              <userEdit ref="editContents" v-bind:selectedid="selectedid" v-bind:is-edit="true"/>
            </section>
          </div>
          <footer class="modal-card-foot">
              <button class="button" type="button" @click="doSave()">決定</button>
              <button class="button" type="button" @click="$parent.close()">閉じる</button>
          </footer>
          {{selectedid}}
        </form>
        `
};
export default {
  name: "AppUserManagementSearchUser",
  hasResult: "false",
  methods: {
    getRowItem: function(value, length) {
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
    //検索処理
    search: function() {
      if (
        this.searchConditions.officeCode ||
        this.isLength(this.searchConditions.firstName) ||
        this.isLength(this.searchConditions.lastName) ||
        this.searchConditions.roleGroup.length > 0
      ) {
        console.log("検索条件あり");
        this.isSearchConditionNull = false;
        var excuteApi = this.getUserListPOST;
        var successCallBack = this.getUserListSuccess;
        var errorCallBack = this.getUserListError;
        // WebAPI Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
      }
    },
    getUserListPOST: function(client) {
      var roleList = this.setNumArray(this.searchConditions.roleGroup);
      return client.apis.apiMaster.getUserListPOST({
        body: {
          officeCode: this.searchConditions.officeCode,
          lastName: this.searchConditions.lastName,
          firstName: this.searchConditions.firstName,
          roleList: roleList
        }
      });
    },
    getUserListSuccess: function(result) {
      this.searchResult = result.obj;
      this.hasResult = true;
    },
    getUserListError: function(result) {
      this.showErrorMessage(result);
    },
    // ダウンロード処理
    downloadPlan: function() {
      if (
        this.searchConditions.officeCode ||
        this.searchConditions.firstName ||
        this.searchConditions.lastName ||
        this.searchConditions.roleGroup.length > 0
      ) {
        console.log("ダウンロード条件あり");
        var excuteApi = this.downloadUserInfoFilePOST;
        var errorCallBack = this.downloadUserInfoFileError;
        // WebAPI Call
        this.downloadApiCall(excuteApi, errorCallBack);
      } else {
        console.log("ダウンロード条件未入力");
        this.showErrorMessage("ダウンロード条件を指定してください。");
      }
    },
    downloadUserInfoFilePOST: function(client) {
      var roleList = this.setNumArray(this.searchConditions.roleGroup);
      return client.apis.apiMaster.downloadUserInfoFilePOST({
        body: {
          officeCode: this.searchConditions.officeCode,
          lastName: this.searchConditions.lastName,
          firstName: this.searchConditions.firstName,
          roleList: roleList
        }
      });
    },
    downloadUserInfoFileError: function(result) {
      this.showErrorMessage(result);
    },
    refDetail: function(id) {
      this.selectedid = id;
      this.isUserEditActive = true;
    },
    confirmCustomDelete: function(id, email) {
      this.selectedid = id;
      this.selectedmail = email;
      this.$dialog.confirm({
        title: "ユーザ削除",
        message: "このユーザを削除します。よろしいですか？",
        confirmText: "削除する",
        cancelText: "キャンセル",
        type: "is-info",
        hasIcon: true,
        onConfirm: () => {
          // WebAPI Call
          var excuteApi = this.deleteUserInfoPOST;
          var successCallBack = this.deleteSuccess;
          var errorCallBack = this.deleteError;
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      });
    },
    deleteUserInfoPOST: function(client) {
      return client.apis.apiMaster.deleteUserInfoPOST({
        body: {
          id: this.selectedid,
          mail: this.selectedmail
        }
      });
    },
    deleteSuccess: function(result) {
      this.showSuccess(result);
      //もう一回検索
      this.search();
    },
    deleteError: function(result) {
      this.showErrorMessage(result);
    }
  },
  data() {
    var roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    return {
      searchResult,
      officeMaster,
      hasResult: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      isUserEditActive: false,
      searchConditions: {
        officeCode: "",
        lastName: "",
        firstName: "",
        roleGroup: []
      },
      isSearchConditionNull: false,
      selectedid: [],
      selectedmail: "",
      roleId: roleId
    };
  },
  filters: {
    officeFilter: function(value) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    }
  },
  components: {
    "userEdit-modal": userEditForm
  },
  created: function() {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppUserManagementSearchUser.vue